/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Scattered_EyebrowInputs */

const en_why_listening_scattered_eyebrow = /** @type {(inputs: Why_Listening_Scattered_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The usual setup`)
};

const es_why_listening_scattered_eyebrow = /** @type {(inputs: Why_Listening_Scattered_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo habitual`)
};

/**
* | output |
* | --- |
* | "The usual setup" |
*
* @param {Why_Listening_Scattered_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_scattered_eyebrow = /** @type {((inputs?: Why_Listening_Scattered_EyebrowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Scattered_EyebrowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_scattered_eyebrow(inputs)
	return en_why_listening_scattered_eyebrow(inputs)
});